import { TranscriptionQuotaQuery, TranscriptionQuotaResult } from '@dreryk/egabinet-ai-assistant-frontend-api';

import { useCqrsGet, UseCqrsQueryResult } from '@dreryk/command-query-react-common';

export const useTranscriptionQuota = (): UseCqrsQueryResult<TranscriptionQuotaResult> => {
   return useCqrsGet<TranscriptionQuotaResult>(() => new TranscriptionQuotaQuery());
};
